<template>
 <div>
    <el-form ref="form" :model="form2" label-width="180px"  >
        <el-form-item label="营业信息" class="grid-content bg-purple-dark">
        </el-form-item>
        <el-form-item label="法人/经营者身份证正面：">   <div v-if="idcards_front !== ''" > <img :src= "getImgUrl()"  style="width: 300px;height: 200px; " /></div></el-form-item>
        <el-form-item label="法人/经营者身份证反面："> <div v-if="idcards_back !== ''" ><img :src= "getImgUrl2()" style="width: 300px;height: 200px; "/></div></el-form-item>
        <el-form-item label="姓名：">{{legal}}</el-form-item>
        <el-form-item label="证件类型：">{{contractno}}</el-form-item>
        <el-form-item label="证件号：">{{identification_number}}</el-form-item>
        <el-form-item label="法人手机号：">{{mobileNo}}</el-form-item>
        <el-form-item label="营业执照（小微商户请忽略）："><div v-if="business_img !== ''" ><img :src= "getImgUrl3()" style="width: 300px;height: 200px; "/></div></el-form-item>
        <el-form-item label="注册号：">{{business_number}}</el-form-item>
        <el-form-item label="名称：">{{agentname}}</el-form-item>
        <el-form-item label="类型：">{{one_type_name}}</el-form-item>
        <el-form-item label="地址：">{{compaddress}}</el-form-item>
        <el-form-item label="法定代表人/经营者：">{{holder_name}}</el-form-item>
        <el-form-item label="营业期限：">{{contractstdate}}-{{contractendate}}</el-form-item>

    </el-form>

     <el-form ref="form" :model="form3" label-width="180px"  >
         <el-form-item label="结算信息" class="grid-content bg-purple-dark">
         </el-form-item>
         <el-form-item label="账户类型：">{{legal_type}}</el-form-item>
         <el-form-item label="结算类型：">{{legal_settle}}</el-form-item>
         <div  v-if="checked_one">
             <el-form-item label="非法人授权书：">   <div v-if="power_attorney !== ''" > <img :src= "getImgUrl15()"  style="width: 300px;height: 200px; " /></div></el-form-item>
             <el-form-item label="非法人身份证人像面：">   <div v-if="legal_idcards_front !== ''" > <img :src= "getImgUrl16()"  style="width: 300px;height: 200px; " /></div></el-form-item>
             <el-form-item label="非法人身份证国徽面："> <div v-if="legal_idcards_back !== ''" ><img :src= "getImgUrl17()" style="width: 300px;height: 200px; "/></div></el-form-item>
             <el-form-item label="非法人银行预留号码：">{{legal_moblie}}</el-form-item>
             <el-form-item label="非法人身份证号：">{{legal_card}}</el-form-item>
         </div>
         <el-form-item label="经营者银行卡/对公账户开户许可证："><div v-if="industry_license !== ''" ><img :src= "getImgUrl4()" style="width: 300px;height: 200px; "/></div></el-form-item>
         <el-form-item label="开户总行银行：">{{deposit_bank}}</el-form-item>
         <el-form-item label="开户支行城市：">{{account_city}}</el-form-item>
         <el-form-item label="开户支行所在支行：">{{bank_branch}}</el-form-item>
         <el-form-item label="开户名称：">{{account_name}}</el-form-item>
         <el-form-item label="开户账号：">{{bank_account}}</el-form-item>

     </el-form>

     <el-form ref="form" :model="form4" label-width="180px"  >
         <el-form-item label="基本信息" class="grid-content bg-purple-dark">
         </el-form-item>
         <el-form-item label="店铺LOGO："><div v-if="agentlogo !== ''" ><img :src= "getImgUrl55()" style="width: 300px;height: 200px; "/></div></el-form-item>
         <el-form-item label="店内门头照："><div v-if="agent_face !== ''" ><img :src= "getImgUrl5()" style="width: 300px;height: 200px;  "/></div></el-form-item>
         <el-form-item label="店内环境照片："><div v-if="agent_shop !== ''" ><img :src= "getImgUrl6()" style="width: 300px;height: 200px;  "/></div></el-form-item>
         <el-form-item label="收银台照："><div v-if="cashier_photo !== ''" ><img :src= "getImgUrl66()" style="width: 300px;height: 200px;  "/></div></el-form-item>
         <el-form-item label="经营省市区：">{{province}}/{{cityname}}/{{areaname}}</el-form-item>
         <el-form-item label="经营地址：">{{compaddress}}</el-form-item>
         <el-form-item label="联系人：">{{legal}}</el-form-item>
         <el-form-item label="手机号码：">{{mobileNo}}</el-form-item>
         <el-form-item label="常用邮箱：">{{email}}</el-form-item>
         <el-form-item label="客服电话：">{{shop_tel}}</el-form-item>
         <el-form-item label="用户简称：">{{shortername}}</el-form-item>

     </el-form>

</div>

</template>
<style>

    .bg-purple-dark {
        background: #e5e9f2;
    }
</style>
<script>
import * as agentService from '@/api/sys/agent'
import util from '@/libs/util.js'
export default {
  name: 'child1',
  props: ['agentid_f'],
  components: { },
  data () {
    return {
      legal: '',
      contractno: '',
      identification_number: '',
      mobileNo: '',
      business_number: '',
      agentname: '',
      one_type_name: '',
      legal_moblie: '',
      legal_card: '',
      legal_settle: '',
      compaddress: '',
      holder_name: '',
      contractstdate: '',
      contractendate: '',
      deposit_bank: '',
      account_city: '',
      bank_branch: '',
      account_name: '',
      bank_account: '',
      compaddress: '',
      legal: '',
      mobileNo: '',
      email: '',
      shop_tel: '',
      shortername: '',
      idcards_front: '',
      idcards_back: '',
      industry_license: '',
      business_img: '',
      legal_type: '',
      agent_face: '',
      agentlogo: '',
      agent_shop: '',
      cashier_photo: '',
      province: '',
      cityname: '',
      areaname: '',
      loading: false,
      checked_one: false,
      oneagent: {},
      form2: {},
      form3: {},
      form4: {},
      editFormVisible: false
    }
  },
  watch: {
    agentid_f (val) {
      console.log('###########')
      this.getTableData()
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    getImgUrl () {
      return 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + this.idcards_front
    },

    getImgUrl2 () {
      return 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + this.idcards_back
    },
    getImgUrl3 () {
      return 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + this.business_img
    },
    getImgUrl4 () {
      return 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + this.industry_license
    },
    getImgUrl5 () {
      return 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + this.agent_face
    },
    getImgUrl6 () {
      return 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + this.agent_shop
    },
    getImgUrl66 () {
      return 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + this.cashier_photo
    },
    getImgUrl55 () {
      return 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + this.agentlogo
    },
    getImgUrl15 () {
      return 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + this.power_attorney
    },
    getImgUrl16 () {
      return 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + this.legal_idcards_front
    },
    getImgUrl17 () {
      return 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + this.legal_idcards_back
    },
    getTableData () {
      var formData4 = new FormData() // 声明一个FormData对象
      formData4.append('agentid', this.agentid_f)
      agentService.getPerfectAgent(formData4).then(data => {
        if (data != null && data != '') {
          this.legal = data.legal
          this.contractno = data.contractno
          this.identification_number = data.identification_number
          this.mobileNo = data.mobileNo
          this.business_number = data.business_number
          this.agentname = data.agentname
          this.one_type_name = data.one_type_name
          this.compaddress = data.compaddress
          this.holder_name = data.holder_name
          this.contractstdate = data.contractstdate
          this.contractendate = data.contractendate
          this.deposit_bank = data.deposit_bank
          this.account_city = data.account_city
          this.bank_branch = data.bank_branch
          this.account_name = data.account_name
          this.bank_account = data.bank_account
          this.compaddress = data.compaddress
          this.legal = data.legal
          this.mobileNo = data.mobileNo
          this.email = data.email
          this.shop_tel = data.shop_tel
          this.shortername = data.shortername
          this.idcards_front = data.idcards_front
          this.idcards_back = data.idcards_back
          this.industry_license = data.industry_license
          this.business_img = data.business_img
          this.legal_type = data.legal_type
          if (data.legal_settle != null && data.legal_settle != '') {
            if (data.legal_settle == '0') {
              this.legal_settle = '法人结算'
              this.checked_one = false
            } else if (data.legal_settle == '1') {
              this.legal_settle = '非法人结算'
              this.checked_one = true
              this.legal_idcards_front = data.legal_idcards_front
              this.legal_idcards_back = data.legal_idcards_back
              this.power_attorney = data.power_attorney
              this.legal_moblie = data.legal_moblie
              this.legal_card = data.legal_card
            }
          }

          this.agent_face = data.agent_face
          this.agentlogo = data.agentlogo
          this.agent_shop = data.agent_shop
          this.cashier_photo = data.cashier_photo
          this.province = data.province
          this.cityname = data.cityname
          this.areaname = data.areaname
        }
      })
    }
  }
}
</script>
